module.exports = __webpack_public_path__ + "static/media/ghost_green.13fd216e.png";